export default "__VITE_ASSET__03d0c04d__"